"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7512],{

/***/ 51883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ SheetRoot; },
  "Z": function() { return /* binding */ Sheet_Sheet; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/useThemeProps.js
var useThemeProps = __webpack_require__(20407);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/styled.js + 1 modules
var styled = __webpack_require__(58609);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/styles/styleUtils.js

/**
 * internal utility
 */
// eslint-disable-next-line import/prefer-default-export
const resolveSxValue = ({
  theme,
  ownerState
}, key, defaultValue) => {
  let parsedValue;
  let sxObject = {};
  function resolveSx(sxProp) {
    if (typeof sxProp === 'function') {
      const result = sxProp(theme);
      resolveSx(result);
    } else if (Array.isArray(sxProp)) {
      sxProp.forEach(sxItem => {
        if (typeof sxItem !== 'boolean') {
          resolveSx(sxItem);
        }
      });
    } else if (typeof sxProp === 'object') {
      sxObject = (0,esm_extends/* default */.Z)({}, sxObject, sxProp);
    }
  }
  if (ownerState.sx) {
    resolveSx(ownerState.sx);
    const value = sxObject[key];
    if (typeof value === 'string' || typeof value === 'number') {
      if (key === 'borderRadius') {
        var _theme$vars;
        if (typeof value === 'number') {
          return `${value}px`;
        }
        parsedValue = ((_theme$vars = theme.vars) == null ? void 0 : _theme$vars.radius[value]) || value;
      }
    }
  }
  return parsedValue || defaultValue;
};
// EXTERNAL MODULE: ./node_modules/@mui/joy/className/index.js
var className = __webpack_require__(26821);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Sheet/sheetClasses.js

function getSheetUtilityClass(slot) {
  return (0,className/* generateUtilityClass */.d6)('JoySheet', slot);
}
const sheetClasses = (0,className/* generateUtilityClasses */.sI)('JoySheet', ['root', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid']);
/* harmony default export */ var Sheet_sheetClasses = ((/* unused pure expression or super */ null && (sheetClasses)));
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/ColorInversion.js
var ColorInversion = __webpack_require__(78653);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Sheet/Sheet.js


const _excluded = ["className", "color", "component", "variant", "invertedColors"];











const useUtilityClasses = ownerState => {
  const {
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', variant && `variant${(0,capitalize/* default */.Z)(variant)}`, color && `color${(0,capitalize/* default */.Z)(color)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getSheetUtilityClass, {});
};
const SheetRoot = (0,styled/* default */.Z)('div', {
  name: 'JoySheet',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => {
  var _theme$variants, _theme$colorInversion;
  const variantStyle = (_theme$variants = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants[ownerState.color];
  const childRadius = resolveSxValue({
    theme,
    ownerState
  }, 'borderRadius');
  return [(0,esm_extends/* default */.Z)({
    '--List-item-stickyBackground': (variantStyle == null ? void 0 : variantStyle.backgroundColor) || (variantStyle == null ? void 0 : variantStyle.background) || theme.vars.palette.background.surface
  }, childRadius !== undefined && {
    '--List-radius': `calc(${childRadius} - var(--variant-borderWidth, 0px))`,
    '--internal-action-radius': `calc(${childRadius} - var(--variant-borderWidth, 0px))`
  }, {
    // TODO: discuss the theme transition.
    // This value is copied from mui-material Sheet.
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: theme.vars.palette.background.surface,
    position: 'relative'
  }), variantStyle, ownerState.invertedColors && ((_theme$colorInversion = theme.colorInversion[ownerState.variant]) == null ? void 0 : _theme$colorInversion[ownerState.color])];
});
const Sheet = /*#__PURE__*/react.forwardRef(function Sheet(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'JoySheet'
  });
  const {
      className,
      color: colorProp = 'neutral',
      component = 'div',
      variant = 'plain',
      invertedColors = false
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    getColor
  } = (0,ColorInversion/* useColorInversion */.VT)(variant);
  const color = getColor(inProps.color, colorProp);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    component,
    invertedColors,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const result = /*#__PURE__*/(0,jsx_runtime.jsx)(SheetRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m["default"])(classes.root, className),
    ref: ref
  }, other));
  if (invertedColors) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ColorInversion/* ColorInversionProvider */["do"], {
      variant: variant,
      children: result
    });
  }
  return result;
});
 false ? 0 : void 0;
/* harmony default export */ var Sheet_Sheet = (Sheet);

/***/ }),

/***/ 86436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextField_TextField; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId.js
var useId = __webpack_require__(57579);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/joy/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(26967);
// EXTERNAL MODULE: ./node_modules/@mui/joy/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(39224);
// EXTERNAL MODULE: ./node_modules/@mui/joy/Input/Input.js + 5 modules
var Input_Input = __webpack_require__(69392);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/styled.js + 1 modules
var styled = __webpack_require__(58609);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/useThemeProps.js
var useThemeProps = __webpack_require__(20407);
// EXTERNAL MODULE: ./node_modules/@mui/joy/className/index.js
var className = __webpack_require__(26821);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/TextField/textFieldClasses.js

function getTextFieldUtilityClass(slot) {
  return (0,className/* generateUtilityClass */.d6)('JoyTextField', slot);
}
const textFieldClasses = (0,className/* generateUtilityClasses */.sI)('JoyTextField', ['root', 'disabled', 'error', 'focused', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'sizeSm', 'sizeMd', 'sizeLg', 'variantPlain', 'variantOutlined', 'variantSoft', 'fullWidth']);
/* harmony default export */ var TextField_textFieldClasses = (textFieldClasses);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/TextField/TextField.js


const _excluded = ["children", "className", "component", "components", "componentsProps", "label", "helperText", "id", "autoComplete", "autoFocus", "placeholder", "defaultValue", "value", "name", "onBlur", "onChange", "onFocus", "color", "disabled", "error", "required", "size", "variant", "fullWidth", "type", "startDecorator", "endDecorator"];












const useUtilityClasses = ownerState => {
  const {
    error,
    disabled,
    variant,
    size,
    color,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', error && 'error', disabled && 'disabled', fullWidth && 'fullWidth', variant && `variant${(0,capitalize/* default */.Z)(variant)}`, size && `size${(0,capitalize/* default */.Z)(size)}`, color && `color${(0,capitalize/* default */.Z)(color)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getTextFieldUtilityClass, {});
};
const TextFieldRoot = (0,styled/* default */.Z)('div', {
  name: 'JoyTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$palette, _theme$vars$palette2, _theme$vars$palette3;
  return (0,esm_extends/* default */.Z)({
    '--FormLabel-margin': '0 0 0.25rem 0',
    '--FormHelperText-margin': '0.25rem 0 0 0',
    '--FormLabel-asterisk-color': theme.vars.palette.danger[500],
    '--FormHelperText-color': (_theme$vars$palette = theme.vars.palette[ownerState.color]) == null ? void 0 : _theme$vars$palette[500]
  }, ownerState.size === 'sm' && {
    '--FormHelperText-fontSize': theme.vars.fontSize.xs,
    '--FormLabel-fontSize': theme.vars.fontSize.xs
  }, {
    [`&.${TextField_textFieldClasses.error}`]: {
      '--FormHelperText-color': theme.vars.palette.danger[500]
    },
    [`&.${TextField_textFieldClasses.disabled}`]: {
      '--FormLabel-color': (_theme$vars$palette2 = theme.vars.palette[ownerState.color || 'neutral']) == null ? void 0 : _theme$vars$palette2.plainDisabledColor,
      '--FormHelperText-color': (_theme$vars$palette3 = theme.vars.palette[ownerState.color || 'neutral']) == null ? void 0 : _theme$vars$palette3.plainDisabledColor
    },
    display: 'flex',
    flexDirection: 'column'
  }, ownerState.fullWidth && {
    width: '100%'
  });
});
const TextField = /*#__PURE__*/react.forwardRef(function TextField(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'JoyTextField'
  });
  const {
      className,
      component,
      components = {},
      componentsProps = {},
      label,
      helperText,
      id: idOverride,
      autoComplete,
      autoFocus,
      placeholder,
      defaultValue,
      value,
      name,
      onBlur,
      onChange,
      onFocus,
      color,
      disabled = false,
      error = false,
      required = false,
      size = 'md',
      variant = 'outlined',
      fullWidth = false,
      type = 'text',
      startDecorator,
      endDecorator
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const id = (0,useId/* default */.Z)(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const formLabelId = label && id ? `${id}-label` : undefined;
  const ownerState = (0,esm_extends/* default */.Z)({
    label,
    helperText,
    startDecorator,
    endDecorator,
    disabled,
    error,
    required,
    size,
    variant,
    fullWidth,
    type
  }, props);
  const classes = useUtilityClasses(ownerState);
  const Input = components.Input || Input_Input/* default */.ZP;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextFieldRoot, (0,esm_extends/* default */.Z)({
    ref: ref,
    as: component,
    className: (0,clsx_m["default"])(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: [label && /*#__PURE__*/(0,jsx_runtime.jsx)(FormLabel/* default */.Z, (0,esm_extends/* default */.Z)({
      htmlFor: id,
      id: formLabelId,
      required: required
    }, componentsProps.label, components.Label && {
      component: components.Label
    }, {
      children: label
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, (0,esm_extends/* default */.Z)({}, componentsProps.input, {
      id: id,
      name: name,
      type: type,
      "aria-describedby": helperTextId,
      autoComplete: autoComplete,
      autoFocus: autoFocus,
      placeholder: placeholder,
      disabled: disabled,
      error: error,
      required: required,
      color: color,
      size: size,
      fullWidth: fullWidth,
      variant: variant,
      defaultValue: defaultValue,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      onFocus: onFocus,
      startDecorator: startDecorator,
      endDecorator: endDecorator
    })), helperText && /*#__PURE__*/(0,jsx_runtime.jsx)(FormHelperText/* default */.Z, (0,esm_extends/* default */.Z)({
      id: helperTextId
    }, componentsProps.helperText, components.HelperText && {
      component: components.HelperText
    }, {
      children: helperText
    }))]
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var TextField_TextField = (TextField);

/***/ }),

/***/ 25977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TypographyContext; },
  "C": function() { return /* binding */ Typography_Typography; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/capitalize.js
var capitalize = __webpack_require__(28320);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(59766);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/getThemeValue.js + 1 modules
var getThemeValue = __webpack_require__(8367);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js


const _excluded = ["sx"];


const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  Object.keys(props).forEach(prop => {
    if (getThemeValue/* propToStyleFunction */.Gc[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!(0,deepmerge/* isPlainObject */.P)(result)) {
        return systemProps;
      }
      return (0,esm_extends/* default */.Z)({}, systemProps, result);
    };
  } else {
    finalSx = (0,esm_extends/* default */.Z)({}, systemProps, inSx);
  }
  return (0,esm_extends/* default */.Z)({}, otherProps, {
    sx: finalSx
  });
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/base/utils/useSlotProps.js
var useSlotProps = __webpack_require__(7293);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/styled.js + 1 modules
var styled = __webpack_require__(58609);
// EXTERNAL MODULE: ./node_modules/@mui/joy/styles/useThemeProps.js
var useThemeProps = __webpack_require__(20407);
// EXTERNAL MODULE: ./node_modules/@mui/joy/className/index.js
var className = __webpack_require__(26821);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Typography/typographyClasses.js

function getTypographyUtilityClass(slot) {
  return (0,className/* generateUtilityClass */.d6)('JoyTypography', slot);
}
const typographyClasses = (0,className/* generateUtilityClasses */.sI)('JoyTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'body1', 'body2', 'body3', 'noWrap', 'gutterBottom', 'startDecorator', 'endDecorator', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid']);
/* harmony default export */ var Typography_typographyClasses = ((/* unused pure expression or super */ null && (typographyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/joy/Typography/Typography.js


const Typography_excluded = ["color", "textColor"],
  _excluded2 = ["component", "componentsProps", "gutterBottom", "noWrap", "level", "levelMapping", "children", "endDecorator", "startDecorator", "variant"];











const TypographyContext = /*#__PURE__*/react.createContext(false);
const useUtilityClasses = ownerState => {
  const {
    gutterBottom,
    noWrap,
    level,
    color,
    variant
  } = ownerState;
  const slots = {
    root: ['root', level, gutterBottom && 'gutterBottom', noWrap && 'noWrap', color && `color${(0,capitalize/* default */.Z)(color)}`, variant && `variant${(0,capitalize/* default */.Z)(variant)}`],
    startDecorator: ['startDecorator'],
    endDecorator: ['endDecorator']
  };
  return (0,composeClasses/* default */.Z)(slots, getTypographyUtilityClass, {});
};
const StartDecorator = (0,styled/* default */.Z)('span', {
  name: 'JoyTypography',
  slot: 'StartDecorator',
  overridesResolver: (props, styles) => styles.startDecorator
})(({
  ownerState
}) => {
  var _ownerState$sx;
  return (0,esm_extends/* default */.Z)({
    display: 'inline-flex',
    marginInlineEnd: 'clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)'
  }, ((_ownerState$sx = ownerState.sx) == null ? void 0 : _ownerState$sx.alignItems) === 'flex-start' && {
    marginTop: '2px' // this makes the alignment perfect in most cases
  });
});

const EndDecorator = (0,styled/* default */.Z)('span', {
  name: 'JoyTypography',
  slot: 'endDecorator',
  overridesResolver: (props, styles) => styles.endDecorator
})(({
  ownerState
}) => {
  var _ownerState$sx2;
  return (0,esm_extends/* default */.Z)({
    display: 'inline-flex',
    marginInlineStart: 'clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)'
  }, ((_ownerState$sx2 = ownerState.sx) == null ? void 0 : _ownerState$sx2.alignItems) === 'flex-start' && {
    marginTop: '2px' // this makes the alignment perfect in most cases
  });
});

const TypographyRoot = (0,styled/* default */.Z)('span', {
  name: 'JoyTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$palette$o, _theme$variants$owner;
  return (0,esm_extends/* default */.Z)({
    '--Icon-fontSize': '1.25em',
    margin: 0
  }, ownerState.nesting ? {
    display: 'inline'
  } : {
    fontFamily: theme.vars.fontFamily.body,
    // for nested typography, the font family will be inherited.
    display: 'block'
  }, (ownerState.startDecorator || ownerState.endDecorator) && (0,esm_extends/* default */.Z)({
    display: 'flex',
    alignItems: 'center'
  }, ownerState.nesting && (0,esm_extends/* default */.Z)({
    display: 'inline-flex'
  }, ownerState.startDecorator && {
    verticalAlign: 'bottom' // to make the text align with the parent's content
  })), ownerState.level && ownerState.level !== 'inherit' && theme.typography[ownerState.level], ownerState.noWrap && {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, ownerState.gutterBottom && {
    marginBottom: '0.35em'
  }, ownerState.color && {
    color: `rgba(${(_theme$vars$palette$o = theme.vars.palette[ownerState.color]) == null ? void 0 : _theme$vars$palette$o.mainChannel} / 1)`
  }, ownerState.variant && (0,esm_extends/* default */.Z)({
    borderRadius: theme.vars.radius.xs,
    paddingBlock: 'min(0.15em, 4px)',
    paddingInline: '0.375em'
  }, !ownerState.nesting && {
    marginInline: '-0.375em'
  }, (_theme$variants$owner = theme.variants[ownerState.variant]) == null ? void 0 : _theme$variants$owner[ownerState.color]));
});
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  display1: 'h1',
  display2: 'h2',
  body1: 'p',
  body2: 'p',
  body3: 'span',
  body4: 'span',
  body5: 'span',
  inherit: 'p'
};
const Typography = /*#__PURE__*/react.forwardRef(function Typography(inProps, ref) {
  const _useThemeProps = (0,useThemeProps/* default */.Z)({
      props: inProps,
      name: 'JoyTypography'
    }),
    {
      color,
      textColor
    } = _useThemeProps,
    themeProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_useThemeProps, Typography_excluded);
  const nesting = react.useContext(TypographyContext);
  const props = extendSxProp((0,esm_extends/* default */.Z)({}, themeProps, {
    color: textColor
  }));
  const {
      component: componentProp,
      componentsProps = {},
      gutterBottom = false,
      noWrap = false,
      level: levelProp = 'body1',
      levelMapping = {},
      children,
      endDecorator,
      startDecorator,
      variant
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);
  const level = nesting ? inProps.level || 'inherit' : levelProp;
  const component = componentProp || (nesting ? 'span' : levelMapping[level] || defaultVariantMapping[level] || 'span');
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    level,
    component,
    color: variant ? color != null ? color : 'neutral' : color,
    gutterBottom,
    noWrap,
    nesting,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const rootProps = (0,useSlotProps/* default */.Z)({
    elementType: TypographyRoot,
    externalSlotProps: componentsProps.root,
    ownerState,
    additionalProps: {
      ref,
      as: component
    },
    externalForwardedProps: other,
    className: classes.root
  });
  const startDecoratorProps = (0,useSlotProps/* default */.Z)({
    elementType: StartDecorator,
    externalSlotProps: componentsProps.startDecorator,
    ownerState,
    className: classes.startDecorator
  });
  const endDecoratorProps = (0,useSlotProps/* default */.Z)({
    elementType: EndDecorator,
    externalSlotProps: componentsProps.endDecorator,
    ownerState,
    className: classes.endDecorator
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TypographyContext.Provider, {
    value: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TypographyRoot, (0,esm_extends/* default */.Z)({}, rootProps, {
      children: [startDecorator && /*#__PURE__*/(0,jsx_runtime.jsx)(StartDecorator, (0,esm_extends/* default */.Z)({}, startDecoratorProps, {
        children: startDecorator
      })), children, endDecorator && /*#__PURE__*/(0,jsx_runtime.jsx)(EndDecorator, (0,esm_extends/* default */.Z)({}, endDecoratorProps, {
        children: endDecorator
      }))]
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Typography_Typography = (Typography);

/***/ })

}]);